<main data-qa="bad-gateway-page">
  <div class="page-layout">
    <div class="content">
      <h1>502</h1>
      <div class="main-text">
        <div>
          <div class="heading">
            <div class="icon">
              <app-icon
                icon="warning-alt"
                iconSize="64"
              ></app-icon>
            </div>
            <div class="text">Bad Gateway</div>
          </div>
          <p class="description-text">
            The server encountered a temporary error and could not complete your request.
          </p>
          <div class="description">
            @if (helpLinkUrl$ | async; as helpLinkUrl) {
              <p class="mt-3 description-text">
                You can try again in 30 seconds and if it doesn't work
                <a [href]="helpLinkUrl" target="_blank">contact us</a>.
              </p>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
